import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import { streamSelect, streamUnSelect, closeModalMessage } from 'common/actions/appActions';
import authenticationAware from 'webapp/common/authenticationAware';

class BroadcastPicker extends Component {
    constructor(props) {
        super(props);
        this.getMetadataClass = this.getMetadataClass.bind(this);
        this.renderMetaSource = this.renderMetaSource.bind(this);
        this.renderBlackoutPill = this.renderBlackoutPill.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    getMetadataClass(showLock = false) {
        const { baseClass } = this.props;

        return classNames(`${baseClass}__meta`, {
            'icon-font-before icon-lock-solid-before': showLock
        });
    }

    handleClick(stream, event) {
        event.preventDefault();

        const { dispatch, onSelectStreamTracking } = this.props;

        // Avoids the `reselected` return logic when clicking the same stream
        dispatch(streamUnSelect());
        // In a multiple modal scenario, we need to dispatch a closeModal prior to stream selection
        dispatch(closeModalMessage());
        stream.feedSwitch = true;
        dispatch(streamSelect(stream));

         /**
         * onSelectStreamTracking is passed down from authenticationAware HOC component
         * When user selects the stream, onSelectStreamTracking in authenticationAware
         * HOC component got triggered. We need to check onSelectStreamTracking nil
         * value before calling it since if newrelic tracking is turned off in config,
         * onSelectStreamTracking will be passed as null value from HOC component
         */
        if (onSelectStreamTracking !== null) {
            onSelectStreamTracking(stream);
        }
    }

    renderMetaSource(stream = {}) {
        const { source: { name } = {} } = stream;

        return name ? (
            <div className={this.getMetadataClass(stream.isLocked)}>
                <span>{name}</span>
            </div>
        ) : null;
    }

    renderBlackoutPill(stream = {}, text = 'BLACKOUT') { // eslint-disable-line class-methods-use-this
        const { blackoutText = '', status = '' } = stream;
        const className = classNames('media-duration media-duration--blackout', {
            'media-duration--live': (status === 'live')
        });

        return (blackoutText && blackoutText !== '') ? (
            <div className={className}>{text}</div>
        ) : null;
    }

    render() {
        const { content, baseClass } = this.props;
        const { streams = [] } = content;

        return streams.length ? (
            <div className={`${baseClass}__wrapper`}>
                {streams.map(stream =>
                    <div
                        className={`${baseClass}__item`}
                        key={stream.id}
                        onClick={(event) => this.handleClick(stream, event)}
                    >
                        <div className={`${baseClass}__item__name`}>
                            <h2 className={`${baseClass}__item__text`}>{stream.name}</h2>
                            {this.renderBlackoutPill(stream)}
                        </div>
                        {this.renderMetaSource(stream)}
                    </div>
                )}
            </div>
        ) : null;
    }
}

BroadcastPicker.propTypes = {
    dispatch: PropTypes.func,
    content: PropTypes.object,
    baseClass: PropTypes.string,
    onSelectStreamTracking: PropTypes.object
};

BroadcastPicker.defaultProps = {
    baseClass: 'watchBroadcast'
};

export default authenticationAware()(BroadcastPicker);



// WEBPACK FOOTER //
// ./app/webapp/modal/messaging/BroadcastPicker.js